import { ReportIcon } from './ReportIcon'
import { BodyFlow, H2Flow, PrimaryButton } from '@monthio/react-components'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Transaction } from '../../../types/budgetApi.types'

const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`

const StyledButton = styled(PrimaryButton)`
	width: 100%;
	margin-top: 16px;
`

export const TableFooter = ({
	selectedTransaction,
	reportTransaction,
}: {
	selectedTransaction: Transaction
	reportTransaction: () => void
}) => {
	const { t } = useTranslation()

	return (
		<div>
			<Header>
				<ReportIcon isSelected={false} isReported />
				<H2Flow>
					{t(
						'budgetCategorizedTransactionsTable-reportIncorrectCategorization-header',
					)}
				</H2Flow>
			</Header>
			<BodyFlow>
				{t(
					'budgetCategorizedTransactionsTable-reportIncorrectCategorization-text',
				)}
			</BodyFlow>
			<StyledButton
				onClick={reportTransaction}
				disabled={selectedTransaction.isReported}
			>
				{t(
					'budgetCategorizedTransactionsTable-reportIncorrectCategorization-button',
				)}
			</StyledButton>
		</div>
	)
}
